import failedToLoad from "@/assets/images/failed-to-load.webp";

import styles from "./styles";

export default function NFTMedia({ media, isLoading = false }: { media: string; isLoading?: boolean }) {
  if (isLoading) {
    return <styles.Loading />;
  }
  return (
    <img
      src={media}
      alt={media}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = failedToLoad;
      }}
    />
  );
}
